import React from 'react';
import { Icon } from '../../icons';
import { useCategories } from '@hooks';

interface CategoryFilterProps {
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
  showAllOption?: boolean;
  color?: string; // FX-169: permite personalizar el color desde el padre
}

export const CategoryFilter: React.FC<CategoryFilterProps> = ({
  selectedCategory,
  onCategoryChange,
  showAllOption = true,
  color = 'blue',
}) => {

  const { categories, loading } = useCategories();


  // Opción especial para mostrar "Todos los Tipos" al final
  const allOption = showAllOption
    ? [{ id: 'all', name: 'Todos los Tipos', icon: 'list' }]
    : [];

  const displayCategories = [...categories, ...allOption];

  return (
    <div className="w-full py-4">
      <div className="flex items-center justify-center px-4 pb-2 space-x-4 overflow-x-scroll sm:overflow-x-auto">
        {loading ? (
          <span className="text-gray-400">Cargando categorías...</span>
        ) : (
          displayCategories.map((category) => {
            const isSelected = selectedCategory === category.id;
            // FX-169: color dinámico
            const colorClass = color;
            return (
              <button
                key={category.id}
                onClick={() => onCategoryChange(category.id)}
                className={`category-item cursor-pointer inline-flex flex-col items-center justify-center w-auto sm:min-w-[80px] px-2 py-2 rounded-xl transition-all ${
                  isSelected
                    ? `bg-blue-100/50 border-2 border-${colorClass}-500 text-${colorClass}-700`
                    : `bg-transparent border-2 border-white-200 hover:border-white-300 text-${colorClass}-600`
                }`}
              >
                <Icon
                  name={category.icon ?? 'default'}
                  size={24}
                  title={category.name}
                  className={isSelected ? `text-${colorClass}-600` : 'text-white-500'}
                />
                <span className="mt-2 text-xs font-medium leading-tight text-center whitespace-nowrap">
                  {category.name}
                </span>
              </button>
            );
          })
        )}
      </div>
    </div>
  );
};